<template>
  <div>
  <div v-if="systemLocked" class="system-lockout">
    <v-card class="pa-8 text-center" max-width="600" elevation="8">
      <v-icon x-large color="error" class="mb-4">fa-lock</v-icon>
      <h2 class="mb-4">System zablokowany</h2>
      <p>Brak opłaty za korzystanie z systemu. Opłać ostatnią fakturę aby odzyskać dostęp.</p>
      <v-btn color="error" @click="logout">Wyloguj</v-btn>
    </v-card>
  </div>
  <div v-else-if="!status_permissions && !loading" >
      <v-progress-linear :indeterminate="true"></v-progress-linear>
  </div>
  <TenantSummaryDashboard v-else-if="shouldShowTenantSummaryDashboard" />
  <div v-else class="dashboard container">
    <v-alert v-if="showP1CertWarning && $can('do','POKO_WidocznoscAlertowCertyfikatow')" :type="p1CertsExpired ? 'error' : 'warning'" prominent style="grid-column: 1 / -1" class="mb-0">
      <v-row align="center">
        <v-col class="grow">
          <strong v-if="p1CertsExpired">Certyfikaty P1 wygasły {{ formatP1Date(p1MinExpiryDate) }}.</strong>
          <strong v-else-if="p1CertsExpireSoon">Certyfikaty P1 niebawem wygasną — są ważne do {{ formatP1Date(p1MinExpiryDate) }}.</strong>
          <strong v-else>Nie można odczytać daty ważności certyfikatów P1.</strong>
          Wgraj nowe certyfikaty w ustawieniach firmy.
        </v-col>
        <v-col class="shrink" v-if="$can('do','POKO_Ustawienia_Firmy')">
          <v-btn to="/admin/settings" outlined>Ustawienia firmy</v-btn>
        </v-col>
      </v-row>
    </v-alert>
    <v-hover v-slot:default="{ hover }" v-if="$can('do','POKO_Wizyty') && $can('do','POKO_Kalendarz_Glowny_Pokaz')">
      <v-card to="/visits" v-if="$can('do','POKO_Wizyty')" color="primary white--text" :elevation="hover ? 12 : 2">
        <v-card-title><div><h3 class="headline mb-0">{{$t('FE_DASHBOARD_WIZYTY')}}</h3></div></v-card-title>
        <v-card-text>{{$t('FE_DASHBOARD_WIZYTY_OPIS')}}</v-card-text>
        <v-icon large color="white">fa-calendar</v-icon>          
      </v-card>
    </v-hover >
    <v-hover v-slot:default="{ hover }" v-if="$can('do','POKO_Wizyty_Gabinety') && $can('do','POKO_Kalendarz_Glowny_Pokaz')">
      <v-card to="/visitsrooms" v-if="$can('do','POKO_Wizyty_Gabinety')" color="primary white--text" :elevation="hover ? 12 : 2">
        <v-card-title><div><h3 class="headline mb-0">Wizyty - gabinety</h3></div></v-card-title>
        <v-card-text>Kalendarz wizyt z podziałem na gabinety</v-card-text>
        <v-icon large color="white">fa-calendar</v-icon>          
      </v-card>
    </v-hover >
    <v-hover v-slot:default="{ hover }" v-if="$can('do','POKO_Klienci')">
      <v-card to="/clients" v-if="$can('do','POKO_Klienci')" color="primary white--text" :elevation="hover ? 12 : 2">
        <v-card-title><div><h3 class="headline mb-0">{{$t('FE_DASHBOARD_PACJENCI')}}</h3></div></v-card-title>
        <v-card-text>{{$t('FE_DASHBOARD_PACJENCI_OPIS')}}</v-card-text>
        <v-icon large color="white">fa-user-injured</v-icon>          
      </v-card>
    </v-hover>    
    <v-hover v-slot:default="{ hover }"  v-if="$can('do','POKO_Terapeuci_Edycja')">
      <v-card to="/therapists" v-if="$can('do','POKO_Terapeuci_Edycja')" color="primary white--text" :elevation="hover ? 12 : 2">
        <v-card-title><div><h3 class="headline mb-0">{{$t('FE_DASHBOARD_TERAPEUCI')}}</h3></div></v-card-title>
        <v-card-text>{{$t('FE_DASHBOARD_TERAPEUCI_OPIS')}}</v-card-text>
        <v-icon large color="white">fa-user-md</v-icon>          
      </v-card>
    </v-hover>   
    <v-hover v-slot:default="{ hover }" v-if="$can('do','POKO_Moj_Kalendarz')" > 
      <v-card to="/mycalendar" v-if="$can('do','POKO_Moj_Kalendarz')" color="primary white--text" :elevation="hover ? 12 : 2">
        <v-card-title><div><h3 class="headline mb-0">{{$t('FE_DASHBOARD_MOJ_KALENDARZ')}}</h3></div></v-card-title>
        <v-card-text>{{$t('FE_DASHBOARD_MOJ_KALENDARZ_OPIS')}}</v-card-text>
        <v-icon large color="white">fa-calendar-check</v-icon>          
      </v-card>
    </v-hover>          
    <v-hover v-slot:default="{ hover }" v-if="$can('do','POKO_Reports')">
      <v-card to="/reports" v-if="$can('do','POKO_Reports')" color="primary white--text" :elevation="hover ? 12 : 2">
        <v-card-title><div><h3 class="headline mb-0">{{$t('FE_DASHBOARD_RAPORTY')}}</h3></div></v-card-title>
        <v-card-text>{{$t('FE_DASHBOARD_RAPORTY_OPIS')}}</v-card-text>
        <v-icon large color="white">fa-chart-line</v-icon>          
      </v-card>
    </v-hover>
    <v-hover v-slot:default="{ hover }" v-if="$can('do','POKO_Kursanci')">
      <v-card to="/trainees" v-if="$can('do','POKO_Kursanci')" color="primary white--text" :elevation="hover ? 12 : 2">
        <v-card-title><div><h3 class="headline mb-0">{{$t('FE_DASHBOARD_KURSANCI')}}</h3></div></v-card-title>
        <v-card-text>{{$t('FE_DASHBOARD_KURSANCI_OPIS')}}</v-card-text>
        <v-icon large color="white">fa-user-check</v-icon>
      </v-card>
    </v-hover>
    <v-hover v-slot:default="{ hover }" v-if="$can('do','POKO_Kategorie_Opisow_Edycja')">
      <v-card to="/categories" v-if="$can('do','POKO_Kategorie_Opisow_Edycja')" color="primary white--text" :elevation="hover ? 12 : 2">
        <v-card-title><div><h3 class="headline mb-0">{{$t('FE_DASHBOARD_KATEGORIE_OPISOW')}}</h3></div></v-card-title>
        <v-card-text>{{$t('FE_DASHBOARD_KATEGORIE_OPISOW_OPIS')}}</v-card-text>
        <v-icon large color="white">fa-list</v-icon>
      </v-card>
    </v-hover>
    <v-hover v-slot:default="{ hover }" v-if="$can('do','POKO_Opisy_Edycja')">
      <v-card to="/descriptions" v-if="$can('do','POKO_Opisy_Edycja')" color="primary white--text" :elevation="hover ? 12 : 2">
        <v-card-title><div><h3 class="headline mb-0">{{$t('FE_DASHBOARD_OPISY')}}</h3></div></v-card-title>
        <v-card-text>{{$t('FE_DASHBOARD_OPISY_OPIS')}}</v-card-text>
        <v-icon large color="white">fa-pencil-alt</v-icon>
      </v-card>
    </v-hover>
    <v-hover v-slot:default="{ hover }" v-if="$can('do','POKO_Bufor_P1')">
      <v-card to="/p1bufor" v-if="$can('do','POKO_Bufor_P1')" color="primary white--text" :elevation="hover ? 12 : 2">
        <v-card-title><div><h3 class="headline mb-0">{{$t('FE_DASHBOARD_BUFOR_P1')}}</h3></div></v-card-title>
        <v-card-text>{{$t('FE_DASHBOARD_BUFOR_P1_OPIS')}}</v-card-text>
        <v-icon large color="white">fa-notes-medical</v-icon>
      </v-card>
    </v-hover>
    <v-hover v-slot:default="{ hover }" v-if="$can('do','POKO_WizytyZabiegiKalendarz')">
      <v-card to="/fizykoterapia"  v-if="$can('do','POKO_WizytyZabiegiKalendarz')" color="primary white--text" :elevation="hover ? 12 : 2">
        <v-card-title><div><h3 class="headline mb-0">{{$t('FE_DASHBOARD_ZABIEGI_KALENDARZ')}}</h3></div></v-card-title>
        <v-card-text>{{$t('FE_DASHBOARD_ZABIEGI_KALENDARZ_OPIS')}}</v-card-text>
        <v-icon large color="white">fa-calendar-plus</v-icon>
      </v-card>
    </v-hover>
    <v-hover v-slot:default="{ hover }" v-if="$can('do','POKO_Zabiegi')">
      <v-card to="/zabiegi"  v-if="$can('do','POKO_Zabiegi')" color="primary white--text" :elevation="hover ? 12 : 2">
        <v-card-title><div><h3 class="headline mb-0">{{$t('FE_DASHBOARD_ZABIEGI_FIZYKOTERAPII')}}</h3></div></v-card-title>
        <v-card-text>{{$t('FE_DASHBOARD_ZABIEGI_FIZYKOTERAPII_OPIS')}}</v-card-text>
        <v-icon large color="white">fa-procedures</v-icon>
      </v-card>
    </v-hover>

    <v-hover v-slot:default="{ hover }" v-if="$can('do','POKO_Vouchery') && isVoucheryEnabled">
      <v-card to="/vouchery" v-if="$can('do','POKO_Vouchery') && isVoucheryEnabled" color="primary white--text" :elevation="hover ? 12 : 2">
        <v-card-title><div><h3 class="headline mb-0">{{$t('FE_DASHBOARD_VOUCHERY')}}</h3></div></v-card-title>
        <v-card-text>{{$t('FE_DASHBOARD_VOUCHERY_OPIS')}}</v-card-text>
        <v-icon large color="white">fa-money-check-alt</v-icon>
      </v-card>
    </v-hover>
    <v-hover v-slot:default="{ hover }" v-if="$can('do','POKO_Terapeuci_Przerwy')">
      <v-card to="/przerwy" v-if="$can('do','POKO_Terapeuci_Przerwy')" color="primary white--text" :elevation="hover ? 12 : 2">
        <v-card-title><div><h3 class="headline mb-0">{{$t('FE_DASHBOARD_PRZERWY')}}</h3></div></v-card-title>
        <v-card-text>{{$t('FE_DASHBOARD_PRZERWY_OPIS')}}</v-card-text>
        <v-icon large color="white">fa-coffee</v-icon>
      </v-card>
    </v-hover>
    <v-hover v-slot:default="{ hover }" v-if="$can('do','POKO_Rezerwy')">
      <v-card to="/rezerwy" v-if="$can('do','POKO_Rezerwy')" color="primary white--text" :elevation="hover ? 12 : 2">
        <v-card-title><div><h3 class="headline mb-0">{{$t('FE_DASHBOARD_REZERWY')}}</h3></div></v-card-title>
        <v-card-text>{{$t('FE_DASHBOARD_REZERWY_OPIS')}}</v-card-text>
        <v-icon large color="white">fa-calendar-plus</v-icon>
      </v-card>
    </v-hover>
    <v-hover v-slot:default="{ hover }" v-if="$can('do','POKO_Bramka_SMS')">
      <v-card to="/sms" v-if="$can('do','POKO_Bramka_SMS')" color="primary white--text" :elevation="hover ? 12 : 2">
        <v-card-title><div><h3 class="headline mb-0">{{$t('FE_BRAMKA_SMS')}}</h3></div></v-card-title>
        <v-card-text>{{$t('FE_BRAMKA_SMS_OPIS')}}</v-card-text>
        <v-icon large color="white">fa-mobile-alt</v-icon>
      </v-card>
    </v-hover>
    <v-hover v-slot:default="{ hover }" v-if="$can('do','POKO_InformacjeSMS')">
      <v-card to="/sms-center" color="info white--text" :elevation="hover ? 12 : 2">
        <v-card-title>
          <div><h3 class="headline mb-0">Centrum SMS</h3></div>
          <v-spacer></v-spacer>
          <v-badge v-if="unreadSMSCount > 0" :content="unreadSMSCount" color="error"></v-badge>
        </v-card-title>
        <v-card-text>Przeglądaj i zarządzaj wiadomościami SMS</v-card-text>
        <v-icon large color="white">fa-comments</v-icon>
      </v-card>
    </v-hover>
    <v-hover v-slot:default="{ hover }" v-if="$can('do','POKO_PayU_PrzegladPlatnosci')">
      <v-card to="/payu" v-if="$can('do','POKO_PayU_PrzegladPlatnosci')" color="primary white--text" :elevation="hover ? 12 : 2">
        <v-card-title><div><h3 class="headline mb-0">{{$t('FE_PAYU')}}</h3></div></v-card-title>
        <v-card-text>{{$t('FE_PAYU_OPIS')}}</v-card-text>
        <v-img src="@/assets/payu_new_logo.png" height="50" width="150"></v-img>
      </v-card>
    </v-hover>
    <v-hover v-slot:default="{ hover }" v-if="canAdmin">
      <v-card to="/admin" v-if="canAdmin" color="primary white--text" :elevation="hover ? 12 : 2">
        <v-card-title><div><h3 class="headline mb-0">{{$t('FE_DASHBOARD_ADMINISTRACJA')}}</h3></div></v-card-title>
        <v-card-text>{{$t('FE_DASHBOARD_ADMINISTRACJA_OPIS')}}</v-card-text>
        <v-icon large color="white">fa-cog</v-icon>
      </v-card>
    </v-hover>
  </div>

  <!-- Admin Notification Dialog -->
  <v-dialog v-model="showNotificationDialog" persistent max-width="600" v-if="currentNotification">
    <v-card>
      <v-card-title class="headline">{{ currentNotification.title }}</v-card-title>
      <v-card-text>
        <div v-html="renderedNotificationContent"></div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="dismissNotification">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </div>
</template>

<script>
import {  mapActions, mapState } from "vuex";
import { ability } from "@/store/ability";
import {settingsService, visitService, notificationService} from '@/services/'
import { marked } from 'marked'
marked.setOptions({ breaks: true });
import TenantSummaryDashboard from './TenantSummaryDashboard.vue'
import dayjs from 'dayjs'

export default {
  name: "Dashboard",
  data() {
    return {
      loading: false,
      unreadSMSCount: 0,
      unreadNotifications: [],
      showNotificationDialog: false,
      currentNotificationIndex: 0,
      systemLocked: false,
      p1Status: null
    };
  },
  components: {
    TenantSummaryDashboard
  },
  computed: {
    ...mapState('featuresModule',['features']),
    status_permissions: function() {
      return this.$store.getters['account/status_permissions']
    },
    shouldShowTenantSummaryDashboard: function() {
      // Show TenantSummaryDashboard if:
      // 1. User has POKO_TenantSwitching permission
      // 2. FEATURE 'Zmiana Firm' is enabled
      // 3. User is NOT a POKO_SystemAdmin
      return ability.can('do', 'POKO_TenantSwitching') &&
             this.features && this.features['Zmiana Firm'] &&
             !ability.can('do', 'POKO_SystemAdmin');
    },
    canAdmin: function() {
      if(ability.can('do','Pages.Users') ||
          ability.can('do','Pages.Roles') ||
          ability.can('do','POKO_Rooms_Edycja') ||
          ability.can('do','POKO_SystemAdmin'))
            return true;
      return false;
    },
    isSmsEnabled: function() {
      return this.features && this.features.SendSMS
    },
    isVoucheryEnabled: function() {
      return this.features && this.features.Vouchery
    },
    p1MinExpiryDate: function() {
      if (!this.p1Status || !this.p1Status.certificatesUploaded)
        return null
      let dates = [this.p1Status.wssExpiryDate, this.p1Status.tlsExpiryDate].filter(d => d)
      if (dates.length === 0)
        return null
      return dates.sort((a, b) => new Date(a) - new Date(b))[0]
    },
    p1CertsExpired: function() {
      return this.p1MinExpiryDate && dayjs(this.p1MinExpiryDate).isBefore(dayjs())
    },
    p1CertsExpireSoon: function() {
      return this.p1MinExpiryDate && !this.p1CertsExpired && dayjs(this.p1MinExpiryDate).isBefore(dayjs().add(3, 'day'))
    },
    p1CertsUnreadable: function() {
      return this.p1Status && this.p1Status.certificatesUploaded && (!this.p1Status.wssExpiryDate || !this.p1Status.tlsExpiryDate)
    },
    showP1CertWarning: function() {
      return this.p1CertsExpired || this.p1CertsExpireSoon || this.p1CertsUnreadable
    },
    currentNotification: function() {
      if (this.unreadNotifications.length > 0 && this.currentNotificationIndex < this.unreadNotifications.length) {
        return this.unreadNotifications[this.currentNotificationIndex];
      }
      return null;
    },
    renderedNotificationContent: function() {
      if (this.currentNotification && this.currentNotification.content) {
        return marked.parse(this.currentNotification.content);
      }
      return '';
    }
  },
  methods: {
    ...mapActions("account", ["getpermissions"]),
    ...mapActions("title", ["updateTitle"]),
    ...mapActions('featuresModule',["setFeatures"]),
    ...mapActions('companySettingsModule',["setCompanySettings"]),
    dismissNotification() {
      if (!this.currentNotification) return;
      var id = this.currentNotification.id;
      notificationService.markAsRead(id).catch(() => {});
      if (this.currentNotificationIndex < this.unreadNotifications.length - 1) {
        this.currentNotificationIndex++;
      } else {
        this.showNotificationDialog = false;
      }
    },
    logout() {
      localStorage.removeItem('user');
      this.$router.push('/login');
    },
    formatP1Date(val) {
      if (!val) return ''
      return dayjs(val).format("DD-MM-YYYY HH:mm")
    },
  },
  mounted() {
    settingsService.GetCompanySettings().then(resp=> {

      if(resp.data.result) {
        let sett = resp.data.result

        if (sett.systemShutdownDate) {
          if (new Date() >= new Date(sett.systemShutdownDate)) {
            this.systemLocked = true;
            this.setCompanySettings(sett);
            return;
          }
        }

        if (sett.calendarEventHeight && sett.calendarEventHeight > 0) {
          let style = document.getElementById('myCalendarSheet');
          if (!style) {
            style = document.createElement("style");
            style.id = "myCalendarSheet";
            document.head.appendChild(style);
            let sheet = style.sheet;
            sheet.insertRule('.poko-calendar.e-schedule .e-vertical-view .e-time-cells-wrap table td, .poko-calendar.e-schedule .e-vertical-view .e-work-cells { height: ' + sett.calendarEventHeight + 'px;}')
            sheet.insertRule('.poko-calendar.e-schedule .e-month-view .e-work-cells { height: ' + sett.calendarEventHeight + 'px;}')
          } else {
            let sheet = document.getElementById('myCalendarSheet');
            if (sheet) {
              sheet.disabled = true;
              sheet.parentNode.removeChild(sheet);
            }
          }
        }
      }
      this.setCompanySettings(resp.data.result)
    })

    // Fetch admin notifications
    notificationService.getUnread().then(resp => {
      if (resp.data && resp.data.result && resp.data.result.length > 0) {
        this.unreadNotifications = resp.data.result;
        this.currentNotificationIndex = 0;
        this.showNotificationDialog = true;
      }
    }).catch(() => {});

    // Fetch unread SMS count if user has permission
    if (ability.can('do', 'POKO_InformacjeSMS')) {
      visitService.getUnreadSMSCount().then(resp => {
        if (resp.data && resp.data.result !== undefined) {
          this.unreadSMSCount = resp.data.result;
        }
      }).catch(() => {
        // Silently ignore errors
      });
    }
  },
  created() {    
    this.getpermissions();
    this.updateTitle("");  
    settingsService.GetCurrentCompanyFeatures().then(resp => {
      this.setFeatures(resp.data.result)
      if (resp.data.result && resp.data.result.IntegracjaP1) {
        settingsService.getP1CertificatesStatus().then(statusResp => {
          this.p1Status = statusResp.data.result
        }).catch(() => {})
      }
    })
  }

};
</script>

<style>
.system-lockout {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,0.7);
  z-index: 9999;
}
.dashboard {
  margin-top: 50px;
  display: grid;
  grid-gap: 30px;
  grid-template-columns: 1fr 1fr 1fr;
}
@media (max-width: 600px) {
  .dashboard { grid-template-columns: 1fr; }
}
.dashboard .v-card i {
  position: absolute;
  right: 0;
  bottom: 0;
  padding:10px;
}
.dashboard .v-card  .v-image {
  position: absolute;
  right: 0;
  top:0;
}
.dashboard .card {
  cursor: hand;
  background-color: #1a237e;
}
.dashboard .v-card:hover {
  background-color: #75ade5 !important;
}
.dashboard .v-card__text {
  color: white !important;
}
</style>

